
import { useEffect, useRef } from 'react';

// @ts-ignore
const useGlobalInactivity = (timeout, onInactivity, isActive) => {
  const timeoutRef = useRef(null);

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (isActive) {
      // @ts-ignore
      timeoutRef.current = window.setTimeout(onInactivity, timeout);
    }
  };

  const handleActivity = () => {
    resetTimer();
  };

  const lastMouseMove = useRef(0);
  const throttledMouseMove = () => {
    const now = Date.now();
    if (now - lastMouseMove.current > 1000) {
      lastMouseMove.current = now;
      handleActivity();
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('touchstart', handleActivity);
    window.addEventListener('mousemove', throttledMouseMove);


    resetTimer();

    return () => {
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
      window.removeEventListener('mousemove', throttledMouseMove);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isActive, timeout, onInactivity]);
};

export default useGlobalInactivity;
